<template>
  <v-container>
    <v-layout mt-5 pb-3 xs8>
      <v-flex column wrap xs12 sm12 md11 lg10 xl10>
        <h3>
          <v-icon large color="yellow">playlist_add_check</v-icon>
          Welcome to the Evident Extranet
        </h3>
        Using the Evident Extranet, you can order products via Internet and
        check your individual order status online.
        <blockquote>
          Take your orders by the Evident Extranet. With your personal Login you
          are able to order directly. As customer of the Evident Extranet you
          also get access to all product data and your personal order status.
        </blockquote>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 sm12 md11 lg10 xl10>
        <v-alert
          v-if="showMaintenanceWarning"
          color="secondary"
          type="warning"
          :value="true"
        >
          {{ maintenanceMessage }}
        </v-alert>
        <login-form class="pl-5 pr-5 pb-3 pt-2 mt-1"></login-form>
        <v-flex mt-2 text-xs-right>
          <v-btn class="mr-0" outline color="grey" dark to="/reset">
            <v-icon left>vpn_key</v-icon>
            Reset Password
          </v-btn>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import LoginForm from "@/components/LoginForm.vue";

export default {
  components: {
    LoginForm
  },
  computed: {
    ...mapGetters("admin", {
      isMaintenance: "getIsMaintenance",
      maintenanceMessage: "getMaintenanceMessage",
      showMaintenanceWarning: "getShowMaintenanceWarning"
    })
  }
};
</script>
